<template>
  <div class="content" :style="minHeight">
    <header>
      <p>ARCFOX</p>
      <p>惊喜之旅</p>
    </header>
    <div class="conts" v-if="prize_list.length > 0">
      <div class="box">
        <div class="pointer" @click="chou()"></div>
        <div class="boxbg" :style="{transform:rotate_angle,transition:rotate_transition}">
          <div class="turn">
            <div :class="{'wheel-bg6':true}">
              <div class="prize-list">
                <!--<ul class="ulOne" :class="{'win':indexa===0&&prize_list.length==3}">
                  <li v-for="(item,index) in arrOne" :class="{'win':index===indexa}"
                      :style="{ zIndex: item.zIndex,transform: item.deg }"></li>
                </ul>
                <ul class="ulTwo" :class="{'win':indexa===arrOne.length-1}">
                  <li v-for="(item,index) in arrTwo" :class="{'win':index===indexb}"
                      :style="{ zIndex: item.zIndex,transform: item.deg }"></li>
                  <li v-if="prize_list.length==3" :class="{'win':indexb===0}"
                      style="border:none;z-index:4; transform: rotate(329deg)"></li>
                </ul>-->
                <ul class="ulOne">
                  <li v-for="(item,index) in arrOne"
                      :style="{ zIndex: item.zIndex,transform: item.deg }"></li>
                </ul>
                <ul class="ulTwo">
                  <li v-for="(item,index) in arrTwo"
                      :style="{ zIndex: item.zIndex,transform: item.deg }"></li>
                  <li v-if="prize_list.length==3" :class="{'win':indexb===0}"
                      style="border:none;z-index:4; transform: rotate(329deg)"></li>
                </ul>
                <div></div>
              </div>
              <div class="prize-list">
                <div class="prize-item" v-for="(item,index) in prize_list" :key="index"
                     :style="{transform:item.troter,width:item.width}">
                  <div class="prize-pic">
                    <img v-if="item.prizeImg" :src="item.prizeImg" :alt="item.prizeName">
                  </div>
                  <div class="prize-name">
                    {{item.prizeName}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--<div class="popup" v-show="toast_control">
      <div class="popbg"></div>
      <div class="popbox">
        <div class="img" :class="{'img1':false}"></div>
        <div class="words1">{{hasPrize.words1}}</div>
        <div class="words2">{{hasPrize.words2}}</div>
        <div class="words3" v-show="hasPrize.words3!=''">{{hasPrize.words3}}</div>
      </div>
      <div class="close" @click="toast_control=false"></div>
    </div>-->
    <footer>
      <span @click="getRule">规则说明</span>
      <p>欢迎加入破界者联盟</p>
      <p>恭喜您获得一次抽奖机会</p>
    </footer>
    <mt-popup class="msgboxDiv" v-model="msgbox" lockScroll="true" pop-transition="popup-fade">
      <div>
        <h2>规则说明</h2>
        <p style="text-align: left">
          1.通过指定活动注册下载 App 的用户，可获得一次抽奖机会；<br/>
          2.每位用户仅享有一次抽奖机会；<br/>
          3.中奖用户请仔细填写收件人、联系方式、收件地址；信息提交后无法修改；<br/>
          4.活动时间：11月22日-12月18日，奖品将于活动结束后7个工作日内邮寄；<br/>
          5.活动最终解释权归ARCFOX所有。
        </p>
        <input type="button" value="我知道了" @click="outMsg()">
      </div>
    </mt-popup>
    <mt-popup class="msgboxDiv" v-model="prizeSend" lockScroll="true" pop-transition="popup-fade">
      <div>
        <p>您的中奖信息已提交<br>奖品将于12月18日后<br>7个工作日内安排发货</p>
        <input type="button" value="我知道了" @click="outSend()">
      </div>
    </mt-popup>
    <mt-popup class="msgboxDiv" v-model="NoPrize" lockScroll="true" pop-transition="popup-fade">
      <div>
        <p>很抱歉~<br>未能抽中奖品，您可参与更多<br>APP活动赚取积分</p>
        <input type="button" value="我知道了" @click="outPrize()">
      </div>
    </mt-popup>
    <mt-popup class="msgboxDiv" v-model="isQualification" lockScroll="true" pop-transition="popup-fade">
      <div>
        <p>很抱歉~<br>您没有参与资格</p>
        <input type="button" value="我知道了" @click="outQua()">
      </div>
    </mt-popup>
    <mt-popup class="popupDiv" v-model="popupVisible" lockScroll="true" pop-transition="popup-fade" :closeOnClickModal="modalFalse">
      <div class="popupMain">
        <h1><img src="../assets/img/congratulations／top@2x.png" alt=""></h1>
        <div class="PrizeDetails">
          <img :src="prize.prizeImg" alt="">
          <h2>恭喜您获得<br/>{{prize.prizeName}}</h2>
          <h3>（图片仅供参考）</h3>
          <p>请填写收货信息后提交领取</p>
          <div class="formDiv" @focusout="inputBlur" @focusin="inputFocus">
            <input type="text" v-model="userName" placeholder="请填写收件人">
            <input type="text" v-model="getPrizeMobile" placeholder="请填写收件人手机号">
            <input type="text" v-model="address" placeholder="请输入收件地址">
            <input type="button" value="提交" @click="Submission()">
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
  import dataServer from '@/api/data'
  const getQuery = (variable) => {
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1]
      }
    }
    return false;
  }
  const actId = getQuery('id')
  const userMobile = getQuery('mobile')
  const userToken = getQuery('token')
  export default {
    data() {
      return {
        modalFalse:false,
        nums: '0', //中奖的下标
        winnum: '0', //中奖的下标
        indexa: '', //中奖的下标在第一个ul下li的index下标，背景变深颜色
        indexb: '', //中奖的下标在第二个ul下li的index下标，背景变深颜色
        toast_control: false, //抽奖结果和活动规则弹出框控制器
        click_flag: true, //是否可以旋转抽奖
        start_rotating_degree: 0, //转盘初始旋转角度
        rotate_angle: 0, //转盘将要旋转的角度
        start_rotating_degree_pointer: 0, //指针初始旋转角度
        rotate_angle_pointer: 0, //指针将要旋转的度数
        rotate_transition: "", //初始化选中的过度属性控制
        rotate_transition_pointer: "transform 12s ease-in-out", //初始化指针过度属性控制
        prize_list: [], //奖品列表
        arrOne: [],
        arrTwo: [],
        shopUid: '',
        userinfo: '',
        prizeinfo: {
          isGet: '',
          prizeInfos: [{
            validTime: '',
            invalidTime: '',
            type: ''
          }]
        }, //中奖优惠券或实物的信息
        hasPrize: {}, //抽奖之后弹出框信息
        prize: {}, //奖品

        isQualification:false,
        prizeSend:false,
        msgbox:false,
        popupVisible:false,
        NoPrize:false,
        userName:'',
        getPrizeMobile:'',
        address:'',
        activityId: '',
        aid:'',
        lotteryId: '',
        batchData:{},
        mobile:'',
        resultData:{},
        chouType: false,
        prizeType: true,
        minHeight: 'min-height: 480px',
      }
    },
    created(){
      this.$nextTick(function () {
        this.getPrizes()
      })
    },
    mounted() {
      this.minHeight = 'min-height: ' + document.documentElement.clientHeight + 'px'
      this.getActivity()
      this.getFindResult()
    },

    methods: {
      /*判断是否符合报名资格*/
      getActivity(){
        let params = {
          activityId: actId,
          token: userToken
        };
        dataServer.findSenior(params).then(result => {
          if (result.status === "SUCCEED"){
            if(result.data.senior === 1){
              this.chouType = true
            } else if(result.data.senior === 3){
              this.chouType = false
              this.popupVisible = true
            } else if(result.data.senior === 4){
              this.chouType = false
              this.popupVisible = false
            } else {
              this.chouType = false
            }
          }
        })
      },
      getPrizes() {
        let params = {
          activityId: actId,
          token: userToken
        };
        dataServer.findPrizes(params).then(res => {
          if(res.status === 'SUCCEED'){
            this.prize_list = res.data
            this.setSan()
          }
        })
      },
      getFindResult(){
        let params = {
          activityId: actId,
          token: userToken
        };
        dataServer.findResult(params).then(result => {
          if(result.status === "SUCCEED"){
            this.prize = result.data
          }
        })
      },
      chou() {
        if(!this.prizeType){
          return
        }
        this.prizeType = false
        if(this.chouType){
          let _this = this;
          _this.indexa = ''
          _this.indexb = ''
          _this.nums = Number(_this.prize_list.length - 1)-Number(_this.winnum)
          let params = {
            activityId: actId,
            mobile: userMobile,
            token: userToken
          };
          dataServer.drawPrizeByChannel(params).then(res => {
            if(res.status === 'SUCCEED'){
              _this.prize = res.data
              if(res.data.prizeName){
                _this.prize_list.forEach((obj,index) => {
                  if(obj.prizeName === res.data.prizeName){
                    _this.winnum = index;
                    _this.rotating(_this.winnum)
                  }
                })
              } else {
                _this.winnum = 3;
                _this.rotating(_this.winnum)
              }
            }
          })
        } else {
          this.isQualification = true;
        }
      },
      setSan() {
        let _this = this
        _this.arrOne = [];
        _this.arrTwo = [];
        _this.rotate_angle = "rotate(" + Math.floor(-360 * 100 / _this.prize_list.length) / 200 + "deg)";
        _this.start_rotating_degree = Math.floor(-360 * 100 / _this.prize_list.length) / 200;
        for (var i = 0; i < _this.prize_list.length; i++) {
          _this.prize_list[i].troter = "rotate(" + Math.floor(360 * 100 / _this.prize_list.length) / 100 * (0.5 + Number(i)) + "deg) translateX(-50%)"
          _this.prize_list[i].width = Math.floor(3.14 * 5.6 / this.prize_list.length) + "rem"
          var item = {
            value: _this.prize_list[i].name,
            zIndex: Number(i) + 1,
            deg: "rotate(" + Math.floor(360 * 100 / this.prize_list.length) * i / 100 + "deg)",
            degnum: i,
          }
          if (i < _this.prize_list.length / 2) {
            _this.arrOne.push(item)
          } else {
            _this.arrTwo.push(item)
          }
        }
      },
      rotating(index) { //转盘转动函数，index值为中奖的下标，后台会返回中奖的id，这边会首先for循环判断中奖的下标
        let _this = this;
        _this.rotate_transition = "transform 6s cubic-bezier(0.25,0.1,0.01,1)";
        if(!_this.click_flag) return;
        var type = 0; // 默认为 0  转盘转动 1 箭头和转盘都转动(暂且遗留)
        var during_time = 5; // 默认为1s
        var result_index = index; // 最终要旋转到哪一块，对应prize_list的下标
        var rand_circle = 6; // 附加多转几圈，2-3
        _this.click_flag = false; // 旋转结束前，不允许再次触发
        if(type == 0) {
          if(this.start_rotating_degree < 0) {
            this.start_rotating_degree = 0
          } else {
            this.start_rotating_degree = this.start_rotating_degree - Math.floor(360 * 100 / _this.prize_list.length) / 200 -Math.floor(360 * 100 / this.prize_list.length) * _this.nums / 100;
          }
          var rotate_angle = this.start_rotating_degree + 360 * 10 + Math.floor(-360 * 100 / this.prize_list.length) / 200 - Math.floor(360 * 100 / this.prize_list.length) * result_index / 100;
          this.start_rotating_degree = rotate_angle;
          _this.rotate_angle = "rotate(" + rotate_angle + "deg)";
          // 旋转结束后，允许再次触发
          setTimeout(function() {
            _this.click_flag = true;
            if(_this.winnum < _this.prize_list.length / 2) {
              _this.indexb = ''
              _this.indexa = _this.winnum;
            } else {
              _this.indexa = ''
              _this.indexb = _this.winnum - (_this.arrOne.length);
            }
            setTimeout(function() {
              _this.game_over(result_index);
            }, 100)
          }, during_time * 1000 + 1500); // 延时，保证转盘转完
        }
      },
      game_over(index) {
        let _this = this;
        if (index !== 3 && index !== 7) {
          _this.popupVisible = true
        } else {
          _this.NoPrize = true
        }
      },

      getRule(){
        this.msgbox = true
      },
      outQua(){
        this.isQualification = false;
        this.$interaction.JS2APP_backHomePage()
      },
      outMsg(){
        this.msgbox = false
      },
      outSend(){
        this.prizeSend = false
        this.$interaction.JS2APP_backHomePage()
      },
      outPrize(){
        this.NoPrize = false
        this.$interaction.JS2APP_backHomePage()
      },
      /*中奖提交信息*/
      Submission(){
        let userPhone = /^1[3456789]\d{9}$/;
        if(this.userName === '' || this.getPrizeMobile === '' || this.address === ''){
          this.$toast({
            message: '请完善信息',
            duration: 800,
          })
          return
        }
        if(!userPhone.test(this.getPrizeMobile)){
          this.$toast({
            message: '请输入正确的电话号码',
            duration: 800,
          })
          return
        }
        let params = {
          lotteryId: this.prize.id,
          getPrizeMobile: this.getPrizeMobile,
          userName: this.userName,
          address: this.address,
          token: userToken
        };
        dataServer.saveUserInfo(params).then(result => {
          if (result.status === "SUCCEED") {
            this.$toast({
              message: '收货信息提交成功',
              duration: 800,
            })
            this.popupVisible = false
            this.prizeSend = true
          }
        })
      },

      inputBlur(e) {
        // 首先，判断触发事件的目标元素是否是input输入框，我们只关注输入框的行为。
        if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
          // 输入框失去焦点，要把IOS键盘推出页面的滚动部分还原。即将页面滚动到视窗顶部对齐
          this.timer = setTimeout(() => {
            window.scrollTo(0,0);
          }, 0)
        }
      },
      inputFocus(e) {
        // 如果focus，则移除上一个输入框的timer
        if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
          clearTimeout(this.timer);
        }
      }
    }
  }
</script>
<style scoped lang="less">
  input{
    background: none;
    border: none;
  }
  p{
    margin: 0;
    padding: 0;
  }
  .content {
    .conts {
      -webkit-overflow-scrolling: touch;
      .activitytime {
        height: 0.5rem;
        width: 100%;
        position: absolute;
        .timebg {
          width: 100%;
          height: 100%;
          background: #000000;
          opacity: 0.3;
          position: absolute;
          left: 0;
          top: 0;
        }
        .time {
          color: #ffffff;
          line-height: 0.5rem;
          padding-left: 0.2rem;
          font-size: 0.24rem;
          position: relative;
          z-index: 2;
        }
      }
      .rule {
        height: 0.69rem;
        margin-bottom: 2.37rem;
        position: relative;
        .ruletop {
          width: 1.35rem;
          height: 0.46rem;
          position: absolute;
          right: 0;
          bottom: 3px;
          .rulebg {
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            background: #1201d5;
            opacity: 0.3;
            border-top-left-radius: 0.23rem;
            border-bottom-left-radius: 0.23rem;
          }
          .ruletitle {
            text-align: center;
            line-height: 0.46rem;
            font-size: 0.24rem;
            color: #fff;
            position: relative;
            z-index: 3;
            border-top-left-radius: 0.23rem;
            border-bottom-left-radius: 0.23rem;
            border-bottom: 3px solid #1201d5;
          }
        }
      }
      .title {
        height: 0.46rem;
        text-align: center;
        color: #464ff4;
        font-size: 0.28rem;
        line-height: 0.46rem;
        font-weight: 700;
        margin-bottom: 0.24rem;
      }
      .box {
        width: 3.34rem;
        height: 3.34rem;
        margin: auto;
        position: relative;
        overflow: hidden;
        .pointer {
          width: 1rem;
          height: 0.9rem;
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 20;
          transform: translate(-50%, -55%);
          background: url(../assets/images/imgs/pointer.png) top center no-repeat;
          background-size: 100%;
          p {
            font-size: 0.18rem;
            color: #ff4027;
            font-weight: 700;
            text-align: center;
            margin: 0;
          }
          p:first-of-type {
            margin-top: 0.33rem;
          }
        }
        .boxbg {
          width: 3.34rem;
          height: 3.34rem;
          background: url(../assets/images/imgs/box.png) top center no-repeat;
          background-size: 100%;
          padding: 0.13rem;
          .turn {
            width: 3.08rem;
            height: 3.08rem;
            border-radius: 50%;
            overflow: hidden;
            .slice {
              box-sizing: border-box;
              border: 1px solid #eeeeee;
            }
            .win {
              background: #fff4c9 !important;
            }
            .wheel-bg6 {
              width: 100%;
              height: 100%;
              position: relative;
              div {
                text-align: center;
              }
              .prize-list {
                width: 100%;
                height: 100%;
                position: absolute;
                ul {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  overflow: hidden;
                  margin: 0;
                  padding: 0;
                  li {
                    position: absolute;
                    top: 0px;
                    left: 50%;
                    width: 50%;
                    height: 50%;
                    transform-origin: 0 100%;
                    overflow: hidden;
                    cursor: pointer;
                    box-sizing: border-box;
                    border-left: 1px solid #eeeeee;
                    background: #fff;
                  }
                }
                .ulOne {
                  clip: rect(0, 3.08rem, 3.08rem, 1.54rem);
                  li{
                    &:nth-child(2n){
                      background-color: #eef0ff;
                    }
                  }
                }
                .ulTwo {
                  clip: rect(0, 1.54rem, 3.08rem, 0);
                  li{
                    &:nth-child(2n){
                      background-color: #eef0ff;
                    }
                  }
                }
                .prize-item {
                  position: absolute;
                  top: 0;
                  z-index: 12;
                  height: 1.54rem;
                  left: 50%;
                  transform: translateX(-50%);
                  transform-origin: 0 100%;
                  .prize-pic {
                    padding-top: 0.15rem;
                    text-align: center;
                    img {
                      width: 0.37rem;
                    }
                  }
                  .prize-name {
                    width: 0.68rem;
                    margin-left: calc(50% - 0.35rem);
                    padding-top: 0.05rem;
                    font-size: 0.12rem;
                    color: #4798CB;
                  }
                }
              }
            }
          }
        }
        .money {
          position: absolute;
          width: 0.57rem;
          height: 0.55rem;
          top: 2.17rem;
          right: -0.2rem;
        }
      }
      .prizebox {
        margin: 0.3rem;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        padding: 0 0.27rem 0.28rem;
        .prizebg {
          position: absolute;
          border-radius: 4px;
          background: #fff;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          opacity: 0.2;
        }
        .pri {
          .titname {
            color: #fff;
            font-size: 0.32rem;
            text-align: center;
            margin: 0.07rem;
            span {
              img {
                width: 1.51rem;
                height: 0.14rem;
                margin: 0 0.2rem 0.03rem;
              }
            }
            .xuanz {
              img {
                transform: rotate(180deg);
              }
            }
          }
          .prizez {
            width: 100%;
            border: 1px solid #fa54a7;
            border-radius: 4px;
            background: #fff;
            display: flex;
            .couponleft {
              padding-left: 0.3rem;
              width: 3.9rem;
              position: relative;
              height: 100%;
              .iconright {
                div {
                  line-height: 1.1;
                }
                .couponname {
                  font-size: 0.32rem;
                  color: #333333;
                  margin: 0.45rem 0 0.2rem;
                }
                .timevalidity {
                  font-size: 0.24rem;
                  color: #999999;
                  margin-bottom: 0.2rem;
                }
                .timevalidity:last-of-type {
                  margin-bottom: 0.45rem;
                }
              }
            }
            .couponright {
              flex: 1;
              line-height: 1.2rem;
              text-align: center;
              font-size: 0.24rem;
              color: #ff4745;
              vertical-align: top;
              position: relative;
              .money {
                position: relative;
                bottom: 0.02rem;
                margin-right: 0.02rem;
              }
              .moneynum {
                font-size: 0.5rem;
              }
              a {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0.3rem;
                width: 1.5rem;
                height: 0.54rem;
                color: #fff;
                background: #ff4745;
                border-radius: 2px;
                line-height: 0.54rem;
                text-align: center;
                font-size: 0.28rem;
                margin: auto;
                display: block;
              }
              .tel {
                bottom: 0;
                top: 0;
              }
              div {
                position: absolute;
                right: -0.2rem;
                top: 0;
                bottom: 0;
                margin: auto;
                width: 1.28rem;
                height: 1.28rem;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
    .popup {
      width: 100%;
      height: 100%;
      position: fixed;
      z-index: 30;
      top: 0;
      left: 0;
      .popbg {
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.7;
      }
      .popbox {
        width: 2.77rem;
        height: 2.49rem;
        position: absolute;
        top: 27%;
        left: 0;
        right: 0;
        margin: auto;
        background: url(../assets/images/imgs/giftboxbg.png) top center no-repeat;
        background-size: 100%;
        text-align: center;
        .img {
          width: 1.53rem;
          height: 0.7rem;
          margin: auto;
          margin-top: 0.53rem;
          margin-left: 0.56rem;
          background: url(../assets/images/imgs/gift.png) top center no-repeat;
          background-size: 100%;
        }
        .img1 {
          background: url(../assets/images/imgs/regret.png) top center no-repeat;
          background-size: 100%;
        }
        .words1 {
          font-size: 0.2rem;
          color: #ff7d12;
          margin-top: 0.1rem;
        }
        .words2 {
          font-size: 0.14rem;
          color: #ff8422;
        }
        .words3 {
          font-size: 0.12rem;
          color: #999999;
          margin-top: 0.04rem;
        }
      }
      .activityrule {
        width: 2.77rem;
        height: 3.16rem;
        position: absolute;
        top: 20%;
        left: 0;
        right: 0;
        margin: auto;
        background: url(../assets/images/imgs/rulebg.png) top center no-repeat;
        background-size: 100%;
        .rulecnt {
          padding: 1.3rem 0.77rem 0;
          p {
            font-size: 0.24rem;
            line-height: 0.4rem;
            text-align: justify;
            color: #333333;
          }
          p:last-of-type {
            color: #ff4928;
          }
        }
      }
      .close {
        width: 0.25rem;
        height: 0.25rem;
        background: url(../assets/images/imgs/close.png) top center no-repeat;
        background-size: 100%;
        position: absolute;
        top: 75%;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    header{
      margin: 0.3rem auto 0.3rem;
      text-align: center;
      p{
        color: #4798CB;
        font-size: 0.3rem;
      }
    }
    footer{
      text-align: center;
      padding-bottom: 0.2rem;
      p{
        color: #4798CB;
        font-size: 0.2rem;
      }
      span{
        margin: 0.4rem auto 0.2rem;
        display: inline-block;
        width: 0.84rem;
        height: 0.24rem;
        line-height: 0.24rem;
        color: #fff;
        background: url("../assets/images/imgs/guize.png") no-repeat center;
        background-size: 100% 100%;
      }
    }

    .popupDiv{
      width: 90%;
      background: none!important;
      .popupMain{
        width: 100%;
        background: none;
        h1{
          img{
            width: 80%;
            display: block;
            margin: auto;
          }
        }
      }
      .PrizeDetails{
        background-color: #ffffff;
        margin-top: -0.7rem;
        padding-top: 0.4rem;
        border-radius: 8px;
        img{
          width: 50%;
          display: block;
          margin: auto;
        }
        h2{
          margin: 0.06rem;
          font-size: 0.16rem;
          color: #4798CB;
          text-align: center;
          font-weight: lighter;
        }
        h3{
          margin: 0 0 0.06rem;
          font-size: 0.14rem;
          color: #BBBBBB;
          text-align: center;
          font-weight: lighter;
        }
        p{
          margin: 0 auto;
          width: 91%;
          border-top: 1px solid #EEEEEE;
          color: #999999;
          font-size: 0.14rem;
          text-align: left;
          padding-top: 0.1rem;
        }
        .formDiv{
          width: 91%;
          margin: 0.1rem auto 0 auto;
          input{
            width: 100%;
            height: 0.32rem;
            padding-left: 0.1rem;
            line-height: 0.32rem;
            background-color: #F5F7FA;
            color: #333333;
            font-size: 0.14rem;
            border-radius: 8px;
            margin-bottom: 0.1rem;
          }
          input::placeholder{
            color: #CCCCCC;
          }
          input[type=button]{
            background-color: #4798CB;
            color: #ffffff;
            font-size: 0.16rem;
            border-radius: 4px;
            height: 0.32rem;
            line-height: 0.32rem;
            -webkit-appearance:none;
          }
        }
      }
    }
    .msgboxDiv{
      width: 70%;
      border-radius: 8px;
      h2{
        text-align: center;
      }
      p{
        padding: 0.1rem 0.1rem 0.15rem;
        font-size: 0.14rem;
        color: #333333;
        text-align: center;
        line-height: 0.26rem;
        width: 100%;
        margin-top: 0.1rem;
        border-bottom: 1px solid #EEEEEE;
      }
      input{
        text-align: center;
        width: 100%;
        padding: 0.15rem;
        color: #4798CB;
        font-size: 0.16rem;
        outline: none;
      }
    }
  }
</style>
